import { useState } from 'react'

import { useDebouncedValue } from '@/lib/use-debounced-value'

import {
  SEARCH_MIN_CHARS,
  useSearchEntities,
  useSearchEntitiesAcrossRoots,
} from '../../lib/entity-queries'

export function useEntitySearchBox(
  scopeEntityId: string | null,
  acrossRootIds?: string[],
) {
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebouncedValue(query, 250)
  const isSearching = query.trim().length >= SEARCH_MIN_CHARS
  const scopedSearch = useSearchEntities(
    acrossRootIds ? null : scopeEntityId,
    debouncedQuery,
  )
  const acrossRootsSearch = useSearchEntitiesAcrossRoots(
    acrossRootIds ?? [],
    debouncedQuery,
  )
  const search = acrossRootIds ? acrossRootsSearch : scopedSearch
  const results = search.data?.items ?? []
  const pending =
    isSearching && (search.isFetching || query.trim() !== debouncedQuery.trim())

  return { query, setQuery, isSearching, search, results, pending }
}
